import React from 'react';
export interface CollectesDistrict {
  id: string;
  name: string;
  label: string;
  adoption: number; // 0-100
  addresses: number;
  calendars: number;
  reminders: number;
  atnaQuestions: number;
  complaints: number;
  openRate: number;
  points: string;
  labelX: number;
  labelY: number;
}
export const collectesDistricts: CollectesDistrict[] = [{
  id: 'A',
  name: 'Secteur A',
  label: 'A',
  adoption: 82,
  addresses: 8420,
  calendars: 12450,
  reminders: 4120,
  atnaQuestions: 842,
  complaints: 5,
  openRate: 78,
  points: '20,20 200,20 200,160 20,160',
  labelX: 110,
  labelY: 95
}, {
  id: 'B',
  name: 'Secteur B',
  label: 'B',
  adoption: 42,
  addresses: 12480,
  calendars: 8120,
  reminders: 5241,
  atnaQuestions: 1284,
  complaints: 18,
  openRate: 73,
  points: '200,20 400,20 400,160 200,160',
  labelX: 300,
  labelY: 95
}, {
  id: 'C',
  name: 'Secteur C',
  label: 'C',
  adoption: 91,
  addresses: 6240,
  calendars: 9840,
  reminders: 3840,
  atnaQuestions: 412,
  complaints: 2,
  openRate: 84,
  points: '400,20 580,20 580,160 400,160',
  labelX: 490,
  labelY: 95
}, {
  id: 'L',
  name: 'Secteur L',
  label: 'L',
  adoption: 68,
  addresses: 9120,
  calendars: 10240,
  reminders: 4100,
  atnaQuestions: 945,
  complaints: 12,
  openRate: 71,
  points: '20,160 200,160 200,300 20,300',
  labelX: 110,
  labelY: 235
}, {
  id: 'M',
  name: 'Secteur M',
  label: 'M',
  adoption: 74,
  addresses: 11050,
  calendars: 14200,
  reminders: 5800,
  atnaQuestions: 820,
  complaints: 8,
  openRate: 76,
  points: '200,160 400,160 400,300 200,300',
  labelX: 300,
  labelY: 235
}, {
  id: 'O',
  name: 'Secteur O',
  label: 'O',
  adoption: 88,
  addresses: 5400,
  calendars: 8100,
  reminders: 3200,
  atnaQuestions: 310,
  complaints: 3,
  openRate: 81,
  points: '400,160 580,160 580,300 400,300',
  labelX: 490,
  labelY: 235
}, {
  id: 'R',
  name: 'Secteur R',
  label: 'R',
  adoption: 55,
  addresses: 7800,
  calendars: 6400,
  reminders: 2800,
  atnaQuestions: 1102,
  complaints: 15,
  openRate: 68,
  points: '20,300 300,300 300,400 20,400',
  labelX: 160,
  labelY: 355
}, {
  id: 'S',
  name: 'Secteur S',
  label: 'S',
  adoption: 79,
  addresses: 8900,
  calendars: 11500,
  reminders: 4900,
  atnaQuestions: 640,
  complaints: 6,
  openRate: 75,
  points: '300,300 580,300 580,400 300,400',
  labelX: 440,
  labelY: 355
}];
export function getAdoptionStatus(adoption: number): 'critical' | 'warning' | 'on-track' {
  if (adoption < 60) return 'critical';
  if (adoption < 80) return 'warning';
  return 'on-track';
}
export function CollectesHeatMap({
  districts,
  selectedId,
  onSelect
}: {
  districts: CollectesDistrict[];
  selectedId: string;
  onSelect: (id: string) => void;
}) {
  const fillFor = (adoption: number, selected: boolean) => {
    const status = getAdoptionStatus(adoption);
    if (status === 'critical') return selected ? '#DC2626' : '#FCA5A5'; // Red
    if (status === 'warning') return selected ? '#D97706' : '#FCD34D'; // Yellow
    return selected ? '#059669' : '#A7F3D0'; // Green
  };
  return <div className="border border-slate-200 rounded-xl shadow-sm bg-white p-4 flex flex-col gap-3 h-full" data-id="element-1626" data-mp="3jnz7404r0xi2">
      <div className="flex items-center justify-between" data-id="element-1627" data-mp="b8fi5db4218t">
        <div className="text-xs font-medium text-slate-500 uppercase tracking-wide font-body" data-id="element-1628" data-mp="f8fveumh46ea">
          Carte des secteurs · Windsor
        </div>
        <div className="flex items-center gap-3 text-xs text-slate-500 font-body" data-id="element-1629" data-mp="18eujf67kyyt">
          <div className="flex items-center gap-1.5" data-id="element-1630" data-mp="66yjzpk0gsvx">
            <span className="w-2.5 h-2.5 rounded-sm bg-[#FCA5A5] border border-red-300" data-id="element-1631" data-mp="2lz5ivs8a4z74"></span>
            Faible adoption
          </div>
          <div className="flex items-center gap-1.5" data-id="element-1632" data-mp="2qza1pownu60i">
            <span className="w-2.5 h-2.5 rounded-sm bg-[#FCD34D] border border-amber-300" data-id="element-1633" data-mp="2qvw1am7k46vp"></span>
            Adoption moyenne
          </div>
          <div className="flex items-center gap-1.5" data-id="element-1634" data-mp="31gx708olj622">
            <span className="w-2.5 h-2.5 rounded-sm bg-[#A7F3D0] border border-emerald-300" data-id="element-1635" data-mp="31fc7e4nfcwxc"></span>
            Forte adoption
          </div>
        </div>
      </div>
      <svg viewBox="0 0 600 420" className="w-full h-auto mt-auto mb-auto" role="img" aria-label="Carte de chaleur de l'adoption numérique des collectes" data-id="element-1636" data-mp="2si1ygpy2xjvl">
        {districts.map(d => {
        const selected = d.id === selectedId;
        return <g key={d.id} onClick={() => onSelect(d.id)} className="cursor-pointer group" data-id="element-1637" data-mp="3g4s19ti95ih9">
              <polygon points={d.points} fill={fillFor(d.adoption, selected)} stroke={selected ? '#0F172A' : '#ffffff'} strokeWidth={selected ? 3 : 2} className="transition-all" data-id="element-1638" data-mp="24qwjeczyqvmc" />
              <text x={d.labelX} y={d.labelY} textAnchor="middle" dominantBaseline="middle" className="pointer-events-none select-none" fill="#0F172A" fontSize="22" fontWeight="bold" fontFamily="sans-serif" data-id="element-1639" data-mp="1pls3k8ga1nc6">
                {d.label}
              </text>
              <text x={d.labelX} y={d.labelY + 22} textAnchor="middle" dominantBaseline="middle" className="pointer-events-none select-none" fill="#0F172A" fontSize="12" opacity="0.7" fontFamily="sans-serif" data-id="element-1640" data-mp="28gqjbbgi5ycg">
                {d.adoption} %
              </text>
            </g>;
      })}
      </svg>
    </div>;
}